const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全天候监控全网热点，第一时间捕捉热门爆料，让你永远快人一步掌握最新动态。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方核实',
    desc: '每条爆料均经多渠道交叉验证，力求信息真实可靠，避免虚假传闻误导吃瓜群众。',
  },
  {
    icon: 'ri-stack-line',
    title: '深度整理',
    desc: '碎片化信息整合成完整时间线与事件脉络，复杂八卦一目了然，拒绝零散吃瓜。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '读者共创',
    desc: '开放投稿与评论互动，你的线索可能就是下一波热门话题，一起打造最活跃的吃瓜社区。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">平台特色</h2>
          <span className="text-xs text-foreground-400">为什么选择我们</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-secondary-200 transition-colors"
            >
              <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
                <i className={`${feat.icon} text-secondary-600 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}